// Weekly Smart Tip card — Premium/Unlimited only. Hides for free users.
import { useEffect, useState } from "react";
import { Sparkles, RefreshCw, Crown } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

export function NeuWeeklyTip() {
  const { lang } = useI18n();
  const [tip, setTip] = useState(null);
  const [hidden, setHidden] = useState(false);
  const [busy, setBusy] = useState(false);

  const load = async (regenerate = false) => {
    setBusy(true);
    try {
      const { data } = await api.get(`/weekly-tip${regenerate ? "?regenerate=true" : ""}`);
      setTip(data);
    } catch (e) {
      if (e?.response?.status === 402) setHidden(true);
    } finally { setBusy(false); }
  };

  useEffect(() => { load(false); }, []);
  if (hidden) return null;

  return (
    <div data-testid="weekly-tip-card" className="neu p-5 sm:p-6 rounded-3xl space-y-3">
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-full grid place-items-center shadow-md shadow-amber-900/20 shrink-0"
             style={{ background: "linear-gradient(135deg,#f5b800,#d97706)" }}>
          <Sparkles className="w-5 h-5 text-white" strokeWidth={2.2} />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-display text-lg font-bold neu-accent-blue leading-tight">
            {lang === "ar" ? "نصيحة الأسبوع الذكية" : "Weekly Smart Tip"}
          </p>
          <p className="text-[10px] uppercase font-bold text-amber-700 flex items-center gap-1">
            <Crown className="w-3 h-3" /> {lang === "ar" ? "حصرية للمشتركين" : "Premium exclusive"}
          </p>
        </div>
        <button data-testid="weekly-tip-refresh" onClick={() => load(true)} disabled={busy}
          className="w-9 h-9 rounded-full neu-sm grid place-items-center text-slate-500 hover:text-[#1e3a8a] disabled:opacity-50">
          <RefreshCw className={`w-4 h-4 ${busy ? "animate-spin" : ""}`} />
        </button>
      </div>
      {busy && !tip ? (
        <p className="text-sm text-slate-500 py-3 text-center">{lang === "ar" ? "جاري توليد نصيحة..." : "Generating tip..."}</p>
      ) : tip?.tip ? (
        <div className="rounded-2xl neu-inset p-4">
          <p className="text-sm sm:text-base leading-relaxed text-slate-800 whitespace-pre-line">{tip.tip}</p>
        </div>
      ) : (
        <p className="text-sm text-slate-500 py-3 text-center">{lang === "ar" ? "لا توجد نصيحة بعد" : "No tip yet"}</p>
      )}
    </div>
  );
}
